import axios from "axios";
import { TENANCY_ENABLED } from "./tenant";
import { tenantUploadUrl } from "./tenantDocuments";

export async function uploadPortalDocument(url, data, options = {}) {
  if (!TENANCY_ENABLED) {
    const headers = Object.assign({}, options.headers);
    delete headers["Content-Type"];
    delete headers["Access-Control-Allow-Origin"];
    return axios.post(url, data, Object.assign({}, options, { headers }));
  }
  const file = data && data.get("file");
  if (!file || !file.name || !file.size) {
    throw new Error("Please select a non-empty file to upload.");
  }
  const parts = file.name.split("!!~~!!");
  if (parts.length !== 2 || !parts[1] ||
      !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(parts[0])) {
    throw new Error("This upload requires an authorized applicant document owner. Shared staff uploads must be configured separately.");
  }
  return uploadApplicantDocument(parts[0], parts[1], file, options);
}

export async function uploadApplicantDocument(userId, fileName, file, options = {}) {
  if (!TENANCY_ENABLED) {
    throw new Error("Signed applicant uploads require tenant mode.");
  }
  if (!file || !file.size || !fileName || /[\\/?#%]/.test(fileName) ||
      fileName === "." || fileName === "..") {
    throw new Error("The document filename or file is invalid.");
  }
  const extension = fileName.split(".").pop().toLowerCase();
  if (["pdf", "jpeg", "jpg", "png"].indexOf(extension) === -1) {
    throw new Error("Please select a JPEG, JPG, PNG or PDF file.");
  }
  const contentType = file.type || (extension === "pdf" ? "application/pdf" :
    extension === "png" ? "image/png" : "image/jpeg");
  const signedUrl = await tenantUploadUrl(userId, fileName, contentType);
  const response = await axios.put(signedUrl, file, {
    headers: { "Content-Type": contentType },
    onUploadProgress: options.onUploadProgress
  });
  if (response.status < 200 || response.status >= 300) {
    throw new Error("Document storage rejected the upload (HTTP " + response.status + ").");
  }
  return Object.assign({}, response, { status: 200, data: fileName });
}



// WEBPACK FOOTER //
// ./src/services/documentUpload.js